import styled from 'styled-components/macro';

export const AddressesContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const AddressColumn = styled.div`
  width: 50%;
  padding: 30px 15px;
  background-color: #edf3f7;

  h4 {
    font-size: 1.8rem;
    color: #001758;
    font-weight: 300;
    margin: 0 0 20px;
  }
`;

export const AddressLineItem = styled.div`
  font-size: 1.4rem;
  line-height: 1.8rem;
  color: #114754;
`;

export const ActionPageContainer = styled.div`
  padding-top: 30px;
  min-height: 100%;
  display: flex;
  flex-direction: column;
`;

export const Title = styled.h3`
  text-align: center;
  font-size: 2.5rem;
  color: #001758;
  font-family: Lato-Light, sans-serif;
  font-weight: 300;
  line-height: 3.1rem;
  margin: 0 0 20px;
`;

export const Paragraph = styled.p`
  padding-left: 2rem;
  padding-right: 2rem;
  font-family: Lato-Light, sans-serif;
  font-weight: lighter;
  text-align: center;
  font-size: 1.4rem;
  line-height: 1.8rem;
  color: #114754;
`;

// Controls row
export const ControlsContainer = styled.div`
  min-height: 48px;
  padding-top: 1.2rem;
  padding-bottom: 1.2rem;
  display: flex;
  flex-grow: 1;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
`;

export const Button = styled.button`
  background-color: black;
  min-width: 13rem;
  border: 0 #787878;
  border-radius: 2.2rem;
  color: #ffffff;
  font-family: lato, sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.3rem;
  padding: 0.5rem 2rem;
`;

export const BackButton = styled(Button)`
  background-color: #0bc495;
`;

export const ActionButton = styled(Button)`
  background-color: #44b1df;
`;
